export default function Footer() {
  return (
    <footer className="relative z-10 py-6 mt-auto" data-testid="app-footer">
      <div className="container-narrow">
        <div className="flex items-center justify-between text-[10px] mono uppercase tracking-[0.22em] text-[var(--muted)]">
          <span>© MIDIA STORE</span>
          <span className="flex items-center gap-1.5">
            <span className="w-1 h-1 rounded-full bg-[var(--neon)]" />
            powered by misticpay
          </span>
        </div>
      </div>
    </footer>
  );
}
